<template>
  <div class="container-fluid bg-light">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col d-flex justify-content-center align-items-center vh-100">
        <div class="card shadow">
          <img src="@/assets/images/logo-wide-black.png" class="card-img-top pt-4 px-4" />
          <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
            <div v-if="infoMessage" class="alert alert-primary" role="alert">
              {{ infoMessage }}
            </div>
            <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
              <div class="form-group">
                <label for="emailAddress">Email</label>
                <input
                  v-model="emailAddress"
                  type="email"
                  class="form-control"
                  id="emailAddress"
                  placeholder="Email"
                  required
                  :disabled="isWorking"
                  @keyup.enter="signIn"
                />
                <div class="invalid-feedback">
                  Please provide your email address.
                </div>
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="password"
                  placeholder="Password"
                  required
                  :disabled="isWorking"
                  @keyup.enter="signIn"
                />
                <div class="invalid-feedback">
                  Please provide your password.
                </div>
                <small v-if="!newPasswordRequired" class="form-text text-muted text-right">
                  <router-link to="/signin/forgot" v-slot="{ href, navigate }">
                    <a class="btn btn-link btn-sm" :href="href" @click="navigate">Forgot your password?</a>
                  </router-link>
                </small>
              </div>
              <div v-if="newPasswordRequired" class="form-group">
                <label for="newPassword">New Password</label>
                <input
                  v-model="newPassword"
                  type="password"
                  class="form-control"
                  id="newPassword"
                  placeholder="New Password"
                  required
                  :disabled="isWorking"
                  @keyup.enter="signIn"
                />
                <div class="invalid-feedback">
                  Please provide your new password.
                </div>
              </div>
              <button type="button" class="btn btn-primary btn-block" @click="signIn" :disabled="isWorking" @keyup.enter="signIn">
                <span v-if="isWorking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Sign In
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isWorking: false,

      emailAddress: null,
      password: null,
      newPassword: null,
      newPasswordRequired: false,

      formWasValidated: false,
      infoMessage: null,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters("signin", ["redirect"]),
    ...mapGetters("user", ["user"]),
  },
  created() {
    if (this.user) {
      this.$router.push(this.redirect);
      this.$store.commit("signin/setRedirect", "/");
    }
  },
  methods: {
    ...mapActions("cognito", {
      cognitoSignIn: "signIn",
      cognitoSignInWithNewPassword: "completeNewPasswordChallenge",
    }),
    reset() {
      this.isWorking = false;
      this.formWasValidated = false;
      this.infoMessage = null;
      this.errorMessage = null;
    },
    getErrorMessage(err) {
      switch (err.code) {
        case "NotAuthorizedException":
        case "UserNotFoundException":
          return "Invalid email or password.";
        default:
          return err.message;
      }
    },
    signIn() {
      const payload = {
        username: this.emailAddress,
        password: this.password,
        newPassword: this.newPassword,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // workflow
      let promise = this.newPasswordRequired ? this.cognitoSignInWithNewPassword(payload) : this.cognitoSignIn(payload);

      // invoke
      this.isWorking = true;
      return promise
        .then(res => {
          // new password required
          if (res.newPasswordRequired) {
            this.newPasswordRequired = true;
            this.infoMessage = "You must change your password before you can login.";
            return;
          }

          // success
          this.$router.push(this.redirect);
          this.$store.commit("signin/setRedirect", "/");
        })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err);
          this.isWorking = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 400px;
}
</style>
